// Configurazione cache per compro oro consigliati
export const RECOMMENDED_DEALERS_CACHE_CONFIG = {
  // TTL esteso da 2 minuti a 20 minuti
  TTL: 20 * 60 * 1000, // 20 minuti
  
  // TTL per prefetch (più lungo per dati pre-caricati)
  PREFETCH_TTL: 30 * 60 * 1000, // 30 minuti
  
  // TTL per localStorage (persistente tra sessioni)
  LOCALSTORAGE_TTL: 60 * 60 * 1000, // 1 ora
  
  // TTL per cache server-side
  SERVER_CACHE_TTL: 15 * 60 * 1000, // 15 minuti
  
  // Chiavi cache
  CACHE_KEYS: {
    MEMORY: 'recommended-dealers-memory',
    LOCALSTORAGE: 'recommended-dealers-storage',
    PREFETCH: 'recommended-dealers-prefetch',
    SERVER: 'recommended-dealers-server'
  },
  
  // Versione cache per invalidazione
  CACHE_VERSION: '2.0',
  
  // Configurazione stale-while-revalidate
  STALE_WHILE_REVALIDATE: {
    ENABLED: true,
    STALE_TIME: 10 * 60 * 1000, // 10 minuti - dopo questo tempo i dati sono "stale"
    MAX_AGE: 20 * 60 * 1000     // 20 minuti - dopo questo tempo i dati scadono
  },
  
  // Configurazione cache warming
  CACHE_WARMING: {
    ENABLED: true,
    METALS: ['ORO', 'ARGENTO'],
    PRELOAD_ON_INIT: true
  },
  
  // Configurazione retry per fallback
  RETRY_CONFIG: {
    MAX_RETRIES: 3,
    RETRY_DELAY: 1000, // 1 secondo
    EXPONENTIAL_BACKOFF: true
  }
};

// Utility per generare chiavi cache specifiche
export const generateCacheKey = (metal: string, coordinates?: { lat: number; lng: number }): string => {
  const baseKey = `${RECOMMENDED_DEALERS_CACHE_CONFIG.CACHE_KEYS.MEMORY}-${metal}`;
  
  if (coordinates) {
    // Arrotonda le coordinate per migliorare hit rate della cache
    const lat = Math.round(coordinates.lat * 100) / 100;
    const lng = Math.round(coordinates.lng * 100) / 100;
    return `${baseKey}-${lat}-${lng}`;
  }
  
  return baseKey;
};

// Utility per verificare se i dati sono stale
export const isStale = (timestamp: number): boolean => {
  const now = Date.now();
  return (now - timestamp) > RECOMMENDED_DEALERS_CACHE_CONFIG.STALE_WHILE_REVALIDATE.STALE_TIME;
};

// Utility per verificare se i dati sono scaduti
export const isExpired = (timestamp: number): boolean => {
  const now = Date.now();
  return (now - timestamp) > RECOMMENDED_DEALERS_CACHE_CONFIG.STALE_WHILE_REVALIDATE.MAX_AGE;
};
